document.querySelectorAll(".contact-form .js--field__input, .contact-form .js--select__select").forEach(function(el) {
  el.addEventListener("focus", handleFocus);
  el.addEventListener("blur", handleBlur);
  el.addEventListener("input", handleInput);
});

function handleFocus(e) {
  const field = e.target.closest('.field');
  field.classList.add('focused-field');
}

function handleBlur(e) {
  const field = e.target.closest('.field');
  if (e.target.value === '') {
    field.classList.remove('focused-field');
  }
}

function handleInput(e) {
  const field = e.target.closest('.field');
  if (e.target.value !== '' || document.activeElement === e.target) {
    field.classList.add('focused-field');
  } else {
    field.classList.remove('focused-field');
  }
}